var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "#77C002",
    fillOpacity: 0.095
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#computer_svg__clip0_1144_24243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.382 21.396a.511.511 0 100-1.023.511.511 0 000 1.023z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.766 20.995V24.81l.003 8.936v20.8H66.232V46.9l-.001-8.937v-2.345l-.001-2.774-.002-12.948c0-1.898-1.425-3.308-3.342-3.308h-40.67c-1.92 0-3.67 1.388-4.247 3.165-.13.398-.202.815-.202 1.242z",
    fill: "#497700",
    fillOpacity: 0.977
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.45 45.583v3.833H20.623l-.045-27.93c0-.555.498-1.049 1.056-1.049h41.019c.263 0 .486.112.628.293a.788.788 0 01.165.493v2.294l.003 9.644v12.422z",
    fill: "#6DA512"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 49.773v.916c0 .198-.018.394-.055.583-.346 1.854-2.324 3.273-4.712 3.273H17.767c-1.25 0-2.39-.39-3.24-1.03-.772-.576-1.308-1.36-1.472-2.242A3.069 3.069 0 0113 50.69v-.916c0-.324.325-.589.726-.589h56.548c.401 0 .726.264.726.588z",
    fill: "#497700",
    fillOpacity: 0.977
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.902 51.273c-.346 1.855-2.324 3.274-4.712 3.274H17.764c-1.25 0-2.39-.39-3.24-1.03l56.378-2.244z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.901 20.642l24.344 27.355v.984H53.213l-25.285-28.34h10.973zM48.373 48.981l-25.284-28.34h1.477l25.22 28.34h-1.413z",
    fill: "#FCFCFC",
    stroke: "#FCFCFC",
    strokeWidth: 0.408
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.015 19.424a.612.612 0 100-1.225.612.612 0 000 1.225z",
    fill: "#1D232A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#computer_svg__filter0_d_1144_24243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.086 67.411c6.313 0 11.43-5.117 11.43-11.43s-5.117-11.43-11.43-11.43c-6.312 0-11.43 5.117-11.43 11.43s5.118 11.43 11.43 11.43z",
    fill: "#E8E9EA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.191 61.748c-.29 0-.583-.106-.814-.32L50.57 57.91a1.2 1.2 0 011.628-1.762l2.927 2.706 6.789-7.346a1.2 1.2 0 011.762 1.627l-7.602 8.228a1.193 1.193 0 01-.882.386z",
    fill: "#6DA512"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "computer_svg__clip0_1144_24243"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13 16.588)",
    d: "M0 0h58v50.824H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "computer_svg__filter0_d_1144_24243",
    x: 44.432,
    y: 44.143,
    width: 25.309,
    height: 25.309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.816
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.612
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0 0.333333 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1144_24243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1144_24243",
    result: "shape"
  })))));
}
export default SvgComputer;